import { Component, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'app-wall',
  templateUrl: './wall.component.html',
  styleUrls: ['./wall.component.scss']
})
export class WallComponent implements OnInit {
  @HostBinding('attr.visible') visible = null

  constructor() { }

  ngOnInit() {
  }

  show () {
    this.visible = ''
  }

  hide () {
    this.visible = null
  }

}
